import { render, staticRenderFns } from "./ModifyTransaction.vue?vue&type=template&id=3bf78629"
import script from "./ModifyTransaction.vue?vue&type=script&lang=js"
export * from "./ModifyTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports